'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var assetsHelper = require('../../helper/assetsHelper');
var propConst = require('../../constants/propConst');
var appTypes = require('../../types/appTypes');
var projectLoadHelper = require('../../helper/projectLoadHelper');
var _ = require('underscore');
var ColorImage = require('../common/ColorImage');
var envHelper = require('../../helper/envHelper');

/**
 * 图标组件部件
 */
var IconParts = React.createClass({

  propTypes: {
    rotateAngle: React.PropTypes.string,
    imgSource: React.PropTypes.string,
    flipHorizontal: React.PropTypes.bool,
    flipVertical: React.PropTypes.bool,
    URL: React.PropTypes.string,
    partStyle: React.PropTypes.object
  },

  isSVGIcon: false,

  componentWillReceiveProps: function (newProps) {
    this.isSVGIcon = this.props.icon && this.props.icon.iconFontName && this.props.icon.iconCode && parseInt(this.props.icon.iconCode, 10) !== -1;
  },

  componentWillMount: function () {
    this.isSVGIcon = this.props.icon && this.props.icon.iconFontName && this.props.icon.iconCode && parseInt(this.props.icon.iconCode, 10) !== -1;
  },

  initTransformStyle: function (style) {
    var transform;
    var transform3D;
    var rotationAngle = styleHelper.getPropertyValue(this.props, propConst.ROTATION_ANGLE);
    var flipH = styleHelper.getPropertyValue(this.props, propConst.FLIP_HORIZONTAL);
    var flipV = styleHelper.getPropertyValue(this.props, propConst.FLIP_VERTICAL);
    if (rotationAngle && !this.isSVGIcon) {
      switch (rotationAngle) {
      case appTypes.RotationAngle.NINETY:
        transform = 'rotate(90deg)';
        break;
      case appTypes.RotationAngle.ONE_HUNDRED_EIGHTY:
        transform = 'rotate(180deg)';
        break;
      case appTypes.RotationAngle.TWO_HUNDRED_SEVENTY:
        transform = 'rotate(-90deg)';
        break;
      default:
        transform = '';
        break;
      }
    }
    if (flipH && flipV) {
      transform3D = 'rotate3D(0,0,1,180deg)';
    } else if (flipH) {
      transform3D = 'rotate3D(0,1,0,180deg)';
    } else if (flipV) {
      transform3D = 'rotate3D(1,0,0,180deg)';
    }

    if (transform3D) {
      if (transform) {
        transform += ' ';
      }
      transform += transform3D;
    }
    if (transform) {
      style.transform = transform;
    }
  },
  scaleIconCodes: {"62413": 1.139344262295082, "61979": 1.217821782178218},
  scaleIcon: function (style) {
    var ratio = this.scaleIconCodes[this.props.icon.iconCode];
    if (ratio) {
      style.width = Math.round(this.props.w * ratio);
      style.height = Math.round(this.props.h * ratio);
      var offsetX = Math.round((this.props.w - style.width) / 2);
      var offsetY = Math.round((this.props.h - style.height) / 2);
      style.left = offsetX;
      style.top = offsetY;
      style.fontSize = style.width + 'px';
      style.lineHeight = style.width + 'px';
    }
  },

  renderSVGIcon: function () {
    var iconFontName = this.props.icon.iconFontName;
    var style = {
      borderStyle: 'none',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0)',
      pointerEvents: 'none',
      position: 'absolute',
      fontFamily: iconFontName,
      fontSize: Math.min(styleHelper.getWidth(this.props), styleHelper.getHeight(this.props)),
      color: styleHelper.getBackgroundColor(this.props),
      textAlign: 'center',
      lineHeight: styleHelper.getWidth(this.props) + 'px'
    };
    var className = '';

    // 在 iOS 和 macOS 上，jongdefontC 和 jongdefontD 这两个字体的文字内容往上偏移了 11%，这里需要校正。
    if ((envHelper.isMac() || envHelper.isiOS())) {
      if (iconFontName === 'jdiconfontC') {
        className = 'mac-ios-icon-transform-C';
      } else if (iconFontName === 'jdiconfontD') {
        className = 'mac-ios-icon-transform-D';
      }
    }

    //屏蔽企业版字体
    if (iconFontName === 'jdiconfontC' || iconFontName === 'jdiconfontD') {
      return(<div></div>);
    }

    this.initTransformStyle(style);
    this.scaleIcon(style);
    return (
      <div
        id={this.props.id}
        className={className}
        ref="svgIcon"
        key={this.props.id}
        style={style}>
        {String.fromCharCode(this.props.icon.iconCode)}
      </div>
    );
  },

  renderImageIcon: function () {
    var imgStyle;
    var imagePath;

    if (this.props.icon.ID && !_.isEmpty(this.props.icon.ID)) {
      imagePath = assetsHelper.getIcon(this.props.icon.ID);
    } else if (!_.isEmpty(this.props.URL)) {
      imagePath = projectLoadHelper.loadSVG(this.props.URL);
    } else {
      imagePath = assetsHelper.getIcon(this.props.defaultIcon || 'Empty.png');
    }

    imgStyle = {
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
      border: 'none',
      backgroundColor: null,
      position: 'absolute'
    };
    return (<ColorImage
      src={imagePath}
      style={imgStyle}
      k="color_image"
      color={styleHelper.getBackgroundColor(this.props)}
    />);
  },

  render: function () {
    var divStyle;
    divStyle = {
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
      left: styleHelper.getX(this.props),
      top: styleHelper.getY(this.props),
      border: 'none',
      position: 'absolute'
    };

    this.initTransformStyle(divStyle);
    //this.scaleIcon(divStyle);

    return (<div style={divStyle} key={'iconParts' + this.props.controlID}>
      {
        this.isSVGIcon && this.renderSVGIcon()
      }
      {
        !this.isSVGIcon && this.renderImageIcon()
      }
    </div>);
  }

});


module.exports = IconParts;



// WEBPACK FOOTER //
// ./src/views/common/IconParts.jsx